import React, { useEffect, useMemo, useState } from "react";
// import "./FindMember.css";
// import "../CommonStyle.css";
// import "../../Styles/FindMember.css";
import "../../Styles/CommonStyles.scss";
import CurrencyInput from "react-currency-input-field";
// import FMPersonalInfo from "../../components/FindMember/FMPersonalInfo";
// import FMFirmAddress from "../../components/FindMember/FMFirmAddress";
// import FMSections from "../../components/FindMember/FMSections";
// import FMMemberTags from "../../components/FindMember/FMMemberTags";

import {
  Button,
  DeleteButton,
  // Label,
  SecondaryBlueButton,
  // SecondaryButton,
  // SecondaryWhiteButton,
} from "../StyledComp/StyledComp";
import MemberServices from "../../services/MemberServices";
import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { changeCurrentMemberMenu } from "../../store/screenSlice";
// import { screenConfig } from "../../config/screenConfig";
import { resetSearchParameters } from "../../store/searchMemberApiSlice";
import { PageLink } from "../../components/StyledComp/StyledComp";
// import { TextWrapper } from "../../globalStyles";
import { RootState } from "../../store/store";
import { useAppSelector } from "../../store/hooks";
import { IPaymentInfo, IStateType } from "../../store/memberInterfaceStruct";
// import { isGeneratorFunction } from "util/types";
// import Modal from "react-modal";
import ReactModal from "react-modal";
// import InputField from "../StyledComp/InputField";
// import * as routeConfig from "../../config/routes";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs, { Dayjs } from "dayjs";
import {
  // searchMemberApiSlice,
  updateSearchBody,
} from "../../store/searchMemberApiSlice";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  updateSearchParamFlags,
  resetSearchParamFlags,
} from "../../store/hasSearchParamFlags";
import IMember from "../../store/memberInterfaceStruct";
import { updateMemberList } from "../../store/findMemberUpdatedApiSlice";
import {
  setMemberCurrentPage,
  setMemberPaginate,
  setUpdateSortBy,
  setUpdateSortType,
  // updateFM_MemberId,
} from "../../store/memberApiSlice";
import {
  // useTable,
  Column,
  // useSortBy
} from "react-table";
import moment from "moment";
// import AlertIcon from "../../Images/Alert";
import RoundButtonWithIcon from "../StyledComp/RoundButtonWithIcon";
import LeftArrowIcon from "../../Images/LeftArrowIcon";
import { TextField } from "@mui/material";
import {
  ICost,
  IVideoCost,
  ILocation,
  initalOrderItem,
  IOrder,
  // IMembership,
  IOrderItem,
  resetOrderParameters,
  storeAddOrderItemCosts,
  storeAssignOrderItem,
  storeRemoveOrderItemCosts,
  storeAddOrderItemVideoCost,
  storeRemoveOrderItemVideoCost,
  storeUpdateOrder,
  storeUpdateOrderItem,
} from "../../store/orderApiSlice";
import { Controller, useForm } from "react-hook-form";
import { Cost, Location, IEvent } from "../../store/eventApiSlice";
import OrderServices from "../../services/OrderServices";

interface IConfiguration {
  [key: string]: any;
}

interface IProps {
  member?: IMember;
  callOrderAPI: () => void;
  operationType?: string; //"Create", "Edit"
  closeModal?: () => void;
}

const EventMemberPaymentInfo: React.FC<IProps> = (props) => {
  const [configurationList, setConfigurationLists] = useState<IConfiguration>(
    {}
  );
  const dispatch = useDispatch();
  // const navigate = useNavigate();

  const form = useForm<IPaymentInfo>();

  const { register, control, handleSubmit, formState, setValue, trigger } =
    form;
  const { errors, touchedFields, dirtyFields } = formState;

  const eventInfo: IEvent = useSelector(
    (state: RootState) => state.eventapislice.event
  );

  /*   let storeTotalAmount = useAppSelector(
    (store) => store.orderapislice.TotalAmount
  );

  let storeAmountPaid = useAppSelector(
    (store) => store.orderapislice.AmountPaid
  ); */

  const orderInfo: IOrder = useAppSelector((store) => store.orderapislice);

  const [member, setMember] = useState<IMember | undefined>(props.member);

  const [participantType, setParticipantType] = useState<string>("");
  const [TransactionType, setTransactionType] = useState<string>("");
  const [eventCostList, setEventCostList] = useState<ICost[]>([]);
  const [eventCostIdList, setEventCostIdList] = useState<number[]>([]);

  const [datePaid, setDatePaid] = useState<Dayjs | null>(
    orderInfo?.DatePaid ? dayjs(orderInfo?.DatePaid) : null
  );

  const videoCostList: IVideoCost[] = [
    {
      Id: 101,
      CostName: "MemberCost",
      Cost: eventInfo.MemberCost,
    },
    {
      Id: 102,
      CostName: "NonMemberCost",
      Cost: eventInfo.NonMemberCost,
    },
    {
      Id: 103,
      CostName: "PA Credit",
      Cost:
        (parseInt("" + (eventInfo.PACredits ?? "0"), 10) +
          parseInt("" + (eventInfo.PAEthics ?? "0"), 10)) *
        4,
    },
    {
      Id: 104,
      CostName: "NJ Credit",
      Cost:
        (parseInt("" + (eventInfo.NJCredits ?? "0"), 10) +
          parseInt("" + (eventInfo.NJEthics ?? "0"), 10)) *
        4,
    },
  ];
  // const [selectedVideoEventList, setSelectedVideoEventList] = useState<
  //   IOrderItem[]
  // >([]);
  const [eventLocation, setEventLocation] = useState<ILocation>();
  // const [OrderItemCost, setOrderItemCost] = useState<number>(0);

  /*   const [totalAmount, setTotalAmount] = useState<number>(storeTotalAmount);
  const [AmountPaid, setAmountPaid] = useState<number>(storeAmountPaid); */
  // const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);

  const [callAPIflag, setCallAPIflag] = useState<boolean>(false);

  /*   useEffect(() => {
    setTotalAmount(storeTotalAmount); // Update transactionAmount when storeTrasactionAmount changes
    // if (isInitialLoad) {
    //   setIsInitialLoad(false);
    //   // setFormValues();
    // }
  }, [storeTotalAmount]); */

  useEffect(() => {
    if (callAPIflag === true) {
      console.log("before callOrderAPI", orderInfo);
      props.callOrderAPI();
    }

    setCallAPIflag(false);

    console.log("orderInfo Changed:", orderInfo);
  }, [orderInfo]); //callAPIflag

  useEffect(() => {
    if (datePaid && dayjs.isDayjs(datePaid) && datePaid.isValid()) {
      setValue("DatePaid", datePaid, {
        shouldDirty: true,
      });
    }
  }, [datePaid]);

  useEffect(() => {
    if (datePaid !== null) {
      dispatch(
        storeUpdateOrder({
          key: "DatePaid",
          value: dayjs(datePaid, "YYYY-MM-DD").format("YYYY-MM-DD"),
        })
      );
    }
    console.log("Dates2:", datePaid, "-", orderInfo.DatePaid);
  }, [datePaid, orderInfo.DatePaid]);

  const color1 = "#2d6289";
  // const color2 = "#008800";

  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        error: {
          main: color1,
        },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              borderBottomStyle: "solid",
              borderBottomWidth: 1,
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
              // Left: "-4%",
              // Top: "10%",
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
              Left: "-4% !important",
              Top: "10%",
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
      },
    });

  const handleCancel = () => {
    // setOrderEventDetailModalOpen(false);
    setEventCostList([]);
    setEventCostIdList([]);
    // setTotalAmount(0);
    // dispatch(resetOrderParameters());
  };

  const checkRequiredFields = () => {
    let missingFields: string = "Required Fields Missing: ";
    if (
      eventInfo.EventType !== "Video" &&
      (orderInfo.Orders[0].ParticipantType == undefined ||
        orderInfo.Orders[0].ParticipantType == "")
    ) {
      missingFields = missingFields + " ParticipantType, ";
    }
    /* if (orderInfo.TransactionType == undefined || orderInfo.TransactionType == "") {
      missingFields = missingFields + "Payment Type, ";
    } */

    if (missingFields !== "Required Fields Missing: ") {
      console.log("missingFields1:", missingFields);
      alert(missingFields);
      return true;
    } else {
      console.log("No missing field");
      return false;
    }
  };

  const checkIsLocationSelected = () => {
    // console.log(eventLocation);
    if (
      eventInfo.EventType !== "Video" &&
      orderInfo.Orders[0].Location == undefined
    ) {
      alert("Please select Event Location");
      return true;
    } else {
      return false;
    }
  };

  const checkIsCostSelected = () => {
    if (
      orderInfo.Orders[0].Costs == undefined ||
      orderInfo.Orders[0].Costs.length == 0
    ) {
      alert("Please select Event Cost");
      return true;
    } else {
      return false;
    }
  };

  const checkIsAmountPaidEntered = () => {
    if (orderInfo.AmountPaid > 0) {
      return false;
    } else {
      alert("Please enter Amount");
      return true;
    }
  };

  const checkIsAmountPaid = () => {
    if (
      orderInfo.TotalAmount >
      (orderInfo.AmountPaid ?? 0) + (orderInfo.CouponAmount ?? 0)
    ) {
      const userResponse = window.confirm(
        "Amount Paid is less than Total Amount. Do you want to Continue"
      );
      if (userResponse) {
        return false;
      } else {
        return true;
      }
    } else if (
      orderInfo.TotalAmount <
      (orderInfo.AmountPaid ?? 0) + (orderInfo.CouponAmount ?? 0)
    ) {
      const userResponse = window.confirm(
        "Amount Paid is more than Total Amount. Do you want to Continue"
      );
      if (userResponse) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  };

  const addOrderItem = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (checkRequiredFields()) {
      return;
    }
    if (checkIsLocationSelected()) {
      return;
    }
    /* if (checkIsCostSelected()) {
      return;
    } */
    /* if (checkIsAmountPaidEntered()) {
      return;
    } */
    if (checkIsAmountPaid()) {
      return;
    }

    console.log("addOrderItem-member?.Id:", member?.Id);
    if (props.operationType === "CREATE" && member?.Id !== null) {
      dispatch(
        storeUpdateOrder({
          key: "MemberId",
          value: member?.Id!,
        })
      );
      dispatch(
        storeUpdateOrderItem({
          key: "EventId",
          value: eventInfo.Id,
        })
      );
      dispatch(
        storeUpdateOrder({
          key: "OrderType",
          value: eventInfo.EventType!,
        })
      );

      dispatch(
        storeUpdateOrderItem({
          key: "OrderType",
          value: eventInfo.EventType!,
        })
      );

      const dueAmount =
        orderInfo.TotalAmount -
        ((orderInfo.AmountPaid ?? 0) + (orderInfo.CouponAmount ?? 0));
      dispatch(
        storeUpdateOrderItem({
          key: "DueAmount",
          value: dueAmount < 0 ? 0 : dueAmount,
        })
      );

      console.log("CREATE", member?.Id);
    }

    const dueAmount =
      orderInfo.TotalAmount -
      ((orderInfo.AmountPaid ?? 0) + (orderInfo.CouponAmount ?? 0));
    dispatch(
      storeUpdateOrderItem({
        key: "DueAmount",
        value: dueAmount < 0 ? 0 : dueAmount,
      })
    );

    setCallAPIflag(true);
    // props.callOrderAPI();
    handleCancel();
  };

  // const [tempTotalAmount, setTempTotalAmount] = useState<number>(totalAmount);

  const updatePaymentInfo = (e: any, date?: Date | null) => {
    switch (e.target.name) {
      case "ParticipantType":
        // setParticipantType(e.target.value);

        // to handle case when type is changed after cost is selected
        let tempTransactionCost1 = 0;

        if (
          orderInfo &&
          orderInfo.Orders &&
          orderInfo.Orders.length > 0 &&
          orderInfo.Orders[0].Costs &&
          orderInfo.Orders[0].Costs.length > 0
        )
          orderInfo.Orders[0].Costs.map((cost) => {
            if (cost.Cost != null)
              tempTransactionCost1 = tempTransactionCost1 + cost.Cost;
          });
        dispatch(
          storeUpdateOrder({
            key: "TotalAmount",
            value: Number(tempTransactionCost1),
          })
        );
        /* setTotalAmount(tempTransactionCost1);

        console.log("TotalAmount:", tempTotalAmount);
        if (e.target.value !== "Attendee" && totalAmount !== 0) {
          setTempTotalAmount(totalAmount);
          setTotalAmount(0);
          console.log("tempTotalAmount2:", tempTotalAmount);
        } else if (e.target.value === "Attendee") {
          console.log("tempTotalAmount1:", tempTotalAmount);
          setTotalAmount(tempTotalAmount);
        } */

        dispatch(
          storeUpdateOrderItem({
            key: "ParticipantType",
            value: e.target.value,
          })
        );
        break;
      case "TransactionType":
        dispatch(
          storeUpdateOrder({
            key: "TransactionType",
            value: e.target.value,
          })
        );
        break;

      // case "DatePaid":
      //   dispatch(
      //     storeUpdateOrder({
      //       key: "DatePaid",
      //       value: e.target.value,
      //     })
      //   );

      // if (dayjs(e.target.value).isValid()) {
      //   dispatch(
      //     storeUpdateOrder({
      //       key: "DatePaid",
      //       value: dayjs(e.target.value!, "YYYY-MM-DD").format("YYYY-MM-DD"),
      //     })
      //   );
      // }

      // if (dayjs(e.target.value).isValid()) {
      //   setValue(
      //     "DatePaid",
      //     dayjs(e.target.value!, "YYYY-MM-DD HH:mm:ss").format(
      //       "YYYY-MM-DD HH:mm:ss"
      //     ),
      //     {
      //       shouldDirty: true,
      //     }
      //   );
      // }

      // break;

      case "CheckNumber":
        dispatch(
          storeUpdateOrder({
            key: "CheckNumber",
            value: e.target.value,
          })
        );
        break;

      case "AmountPaid":
        //setAmountPaid(Number(e.target.value));
        dispatch(
          storeUpdateOrder({
            key: "AmountPaid",
            value: Number(e.target.value),
          })
        );
        break;
      case "CouponAmount":
        dispatch(
          storeUpdateOrder({
            key: "CouponAmount",
            value: Number(e.target.value),
          })
        );
        break;

      case "LateFee":
        dispatch(
          storeUpdateOrder({
            key: "LateFee",
            value: e.target.value,
          })
        );
        break;

      case "AuthCode":
        dispatch(
          storeUpdateOrder({
            key: "AuthCode",
            value: e.target.value,
          })
        );
        break;

      case "PIcomments":
        dispatch(
          storeUpdateOrder({
            key: "Comments",
            value: e.target.value,
          })
        );
        break;

      case "NoInvoiceFlag":
        dispatch(
          storeUpdateOrder({
            key: "NoInvoice",
            value: e.target.checked,
          })
        );
        break;
      default:
        console.log("default");
        break;
    }
  };

  const handleLocationChange = (event: any) => {
    console.log("handleLocationChange", event.target.value);

    const selectedLocation: ILocation = eventInfo.Locations.find((location) => {
      return location.Id === parseInt(event.target.value);
    })!;

    console.log("selectedLocation", selectedLocation);
    dispatch(
      // storeUpdateOrderItem({ key: "Location", value: selectedLocation })
      storeUpdateOrderItem({
        key: "Location",
        value: { ...selectedLocation, LocationId: event.target.value },
      })
    );

    // console.log("location change event:", event);
    // setAddItemButtonDisabled(false);
    setEventLocation(selectedLocation);
  };

  const handleCostChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    costparam: Cost
  ) => {
    let cost1: ICost = {
      CostId: costparam.Id as number,
      CostName: costparam.CostName,
      Cost: costparam.Cost,
      Id: null,
      OrderId: null,
      SeminarOrderItemId: null,
      EventId: null,
      EventCostVarId: costparam.Id as number,
    };

    console.log("EventCostList1:", eventCostList);
    console.log("clicked cost:", cost1);
    // console.log("ParticipantType", orderInfo.Orders[0].ParticipantType);

    if (event.target.checked) {
      setEventCostList((eventCost) => [...eventCost!, cost1]);
      setEventCostIdList((eventCostId) => [...eventCostId!, cost1.CostId!]);

      if (
        orderInfo &&
        orderInfo.Orders &&
        orderInfo.Orders.length > 0 &&
        (orderInfo.Orders[0].ParticipantType === "Speaker" ||
          orderInfo.Orders[0].ParticipantType === "Moderator")
      ) {
        console.log("Before cost update:", orderInfo);
        dispatch(storeAddOrderItemCosts({ key: "Costs", value: cost1 }));
        dispatch(
          storeUpdateOrder({
            key: "TotalAmount",
            value: 0,
          })
        );
        //setTotalAmount(0);
      }
      // (
      //   orderInfo &&
      //   orderInfo.Orders &&
      //   orderInfo.Orders.length > 0 &&
      //   orderInfo.Orders[0].ParticipantType === "Attendee"
      // )
      else {
        console.log("Before cost update:", orderInfo);
        dispatch(storeAddOrderItemCosts({ key: "Costs", value: cost1 }));
        dispatch(
          storeUpdateOrder({
            key: "TotalAmount",
            value: (orderInfo.TotalAmount ?? 0) + (costparam.Cost ?? 0),
          })
        );
        // setTotalAmount(totalAmount + (costparam.Cost ?? 0));
      }

      console.log("after cost update:", orderInfo);
    } else {
      setEventCostList((eventCostList) =>
        eventCostList!.filter((item) => {
          return item.CostId !== Number(event.target.id);
        })
      );
      setEventCostIdList((eventCostId) =>
        eventCostIdList!.filter((item) => {
          return item !== Number(event.target.id);
        })
      );
      dispatch(storeRemoveOrderItemCosts({ key: "Costs", value: cost1 }));

      if (
        orderInfo &&
        orderInfo.Orders &&
        orderInfo.Orders.length > 0 &&
        orderInfo.Orders[0].ParticipantType === "Attendee"
      ) {
        const costTotal = orderInfo.TotalAmount - (costparam.Cost ?? 0);
        dispatch(
          storeUpdateOrder({
            key: "TotalAmount",
            value: costTotal < 0 ? 0 : costTotal,
          })
        );
        // setTotalAmount(totalAmount - (costparam.Cost ?? 0));
      } else {
        dispatch(
          storeUpdateOrder({
            key: "TotalAmount",
            value: 0,
          })
        );
        //  setTotalAmount(0);
      }
    }
    console.log("EventCostList2:", eventCostList);
  };

  const handleVideoCostChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    videoCostParam: IVideoCost
  ) => {
    let cost1: IVideoCost = {
      Id: videoCostParam.Id,
      CostName: videoCostParam.CostName,
      Cost: videoCostParam.Cost,
    };

    // console.log("EventCostList1:", eventCostList);
    // console.log("clicked cost:", cost1);

    if (event.target.checked) {
      if (
        orderInfo &&
        orderInfo.Orders &&
        orderInfo.Orders.length > 0 &&
        // orderInfo.Orders[0].ParticipantType === "Attendee" &&
        videoCostParam.Cost
      ) {
        // setTotalAmount(videoCostParam.Cost);
      } else {
        //   setTotalAmount(0);
      }

      // console.log("Before cost update:", orderInfo);
      dispatch(storeAddOrderItemVideoCost({ key: "VideoCost", value: cost1 }));
      dispatch(
        storeUpdateOrder({
          key: "TotalAmount",
          value: videoCostParam.Cost as number,
        })
      );
      // console.log("after cost update:", orderInfo);
    } else {
      dispatch(
        storeRemoveOrderItemVideoCost({ key: "VideoCost", value: cost1 })
      );
      // There will be only one entry in this array at any time. so while removing it, I am making
      // everything null
      // setTotalAmount(0);

      dispatch(
        storeUpdateOrder({
          key: "TotalAmount",
          value: 0,
        })
      );
    }
    // console.log("EventCostList2:", eventCostList);
  };

  const deleteOrder = async () => {
    console.log("DELETED");
    if (orderInfo && orderInfo.OrderId !== null) {
      const response = await OrderServices.cancelOrder(orderInfo.OrderId);
      console.log("OrderServices.updateOrder-response", response);
      if (response.data.result != null) {
        alert("Order Deleted successfully");
        handleCancel();
        if (props.closeModal) {
          props.closeModal();
        }
      } else {
        alert(response.data.errors);
        console.log("error");
      }
    }
  };

  return (
    <form className="form-wrapper" onSubmit={(e) => addOrderItem(e)} noValidate>
      {eventInfo.EventType !== "Video" ? (
        <div className="input-field-div-wrapper">
          <select
            className="dropdown-control-large-insidetextfield"
            name="ParticipantType"
            onChange={(e) => {
              updatePaymentInfo(e);
              setParticipantType(e.target.value);
            }}
            value={
              orderInfo &&
              orderInfo.Orders &&
              orderInfo.Orders.length > 0 &&
              orderInfo.Orders[0] !== null
                ? orderInfo.Orders[0].ParticipantType!
                : ""
            }
          >
            <option value={""}>Select Participant Type (*) </option>
            <option value="Attendee">Attendee</option>
            <option value="Moderator">Moderator</option>
            <option value="Speaker">Speaker</option>
          </select>
          <p className="form-error form-error-position">
            {errors.ParticipantType?.message}
          </p>
        </div>
      ) : (
        <></>
      )}
      <div className="input-field-div-wrapper">
        <select
          className="dropdown-control-large-insidetextfield"
          name="TransactionType"
          onChange={(e) => {
            updatePaymentInfo(e);
            setTransactionType(e.target.value);
          }}
          value={orderInfo.TransactionType ?? ""}
        >
          <option value={""}>Select Payment Type </option>
          <option value="American Express">American Express</option>
          <option value="Authorize.net">Authorize.net</option>
          <option value="Check">Check</option>
          <option value="Discover">Discover</option>
          <option value="MasterCard">MasterCard</option>
          <option value="Visa">Visa</option>
          <option value="Offline">Website</option>
          <option value="Online">Online</option>
        </select>
        <p className="form-error form-error-position">
          {errors.TransactionType?.message}
        </p>
      </div>

      <div style={{ width: "28%", marginBottom: "1.8rem" }}>
        <Controller
          control={control}
          name="DatePaid"
          render={({
            field: { onChange, onBlur, value, name, ref },
            fieldState: { error },
          }) => (
            <ThemeProvider theme={muiDatePickerColorTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="datepicker-local"
                  label="Date Paid"
                  value={dayjs(datePaid)}
                  onChange={(date: any) => {
                    setDatePaid(dayjs(date));
                  }}
                />
              </LocalizationProvider>
            </ThemeProvider>
          )}
        />
      </div>

      <div className="horizontal-wrapper-spacebetween-center">
        <div className="input-field-div-wrapper">
          <input
            className="input-field-div-small"
            id="CheckNumber"
            name="CheckNumber"
            placeholder=""
            onChange={(e) => {
              updatePaymentInfo(e);
            }}
            value={orderInfo.CheckNumber ?? ""}
            disabled={false}
            autoComplete="off"
          />
          <label className="form-label" htmlFor="CheckNumber">
            Check Number
          </label>
        </div>
        {/* no late fee for events */}
        {/* <div className="input-field-div-wrapper">
        <input
          className="input-field-div-small"
          id="LateFee"
          name="LateFee"
          placeholder=""
          pattern="[0-9]*"
          onChange={(e) => {
            updatePaymentInfo(e);
          }}
          value={orderInfo.LateFee ?? ""}
          disabled={false}
          autoComplete="off"
        />
        <label className="form-label" htmlFor="LateFee">
          Late Fee
        </label>
      </div> */}

        <div className="input-field-div-wrapper">
          <input
            className="input-field-div-small"
            id="AuthCode"
            name="AuthCode"
            placeholder=""
            onChange={(e) => {
              updatePaymentInfo(e);
            }}
            value={orderInfo.AuthCode ?? ""}
            disabled={false}
            autoComplete="off"
          />
          <label className="form-label" htmlFor="AuthCode">
            Auth Code
          </label>
        </div>
        <div style={{ width: "28%" }}></div>
      </div>

      {/* line 3 */}
      <div
        className="horizontal-wrapper-spacebetween-center"
        style={{ width: "100%" }}
      >
        <div
          className="horizontal-wrapper-spacebetween-center"
          style={{ width: "48%" }}
        >
          {/* <div className="input-field-div-wrapper" style={{ width: "100%" }}> */}
          {eventInfo.EventType !== "Video" ? (
            <div
              className="input-field-div-wrapper-large-nominwidth-nomargin wrapper-minwidth-180px"
              style={{ width: "100%", height: "auto" }}
            >
              <h5 className="section-heading-small">Select Location</h5>
              <select
                className="dropdown-control-large-insidetextfield"
                id="Location"
                // placeholder=""
                style={{ color: "#25284e" }}
                onChange={(e) => {
                  handleLocationChange(e);
                }}
                value={
                  orderInfo &&
                  orderInfo.Orders &&
                  orderInfo.Orders.length > 0 &&
                  orderInfo.Orders[0] !== null &&
                  orderInfo.Orders[0].Location &&
                  orderInfo.Orders[0].Location.LocationId
                    ? orderInfo.Orders[0].Location.LocationId!
                    : ""
                }
              >
                <option value={""}>Select Location </option>
                {eventInfo.Locations?.map((location) => (
                  <option key={location.Id} value={location.Id!}>
                    {/* {Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(location.Cost as number)}- */}
                    {location.Location}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            <></>
          )}
          {/* </div> */}
          {/* </div> */}
          {/* start of cost change */}
          {/* <div className="input-field-div-wrapper"> */}
          <div
            className="costlist"
            style={{ width: "100%", height: "auto", marginTop: "1rem" }}
          >
            {typeof eventInfo.Costs != "undefined" &&
            eventInfo.EventType !== "Video" ? (
              <>
                {/* <div id="CostList"> */}
                <h5 className="section-heading-small">Select Cost</h5>
                {eventInfo.Costs.map((cost) => {
                  return (
                    <div key={cost.Id} className="checkboxgroup">
                      <input
                        id={String(cost.Id)}
                        className="checkbox"
                        type="checkbox"
                        defaultChecked={
                          orderInfo &&
                          orderInfo.Orders &&
                          orderInfo.Orders.length > 0 &&
                          orderInfo.Orders[0] &&
                          orderInfo.Orders[0].Costs &&
                          orderInfo.Orders[0].Costs.length > 0
                            ? orderInfo.Orders[0].Costs.some(
                                (eventCostList) =>
                                  eventCostList.EventCostVarId === cost.Id
                              )
                            : false
                        }
                        onChange={(event) => handleCostChange(event, cost)}
                      />
                      <div className="costname-item">
                        {Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                        }).format(cost.Cost as number)}
                        -{cost.CostName}
                      </div>
                      {/* <span style={{ marginLeft: "5px", color: "#03c04A" }}>
                          {isActive ? "(Purchased)" : <></>}
                        </span> */}
                    </div>
                  );
                })}
                {/* </div> */}
              </>
            ) : eventInfo.EventType === "Video" ? (
              <>
                <h5 className="section-heading-small">Select Cost</h5>
                {videoCostList.map((cost) => {
                  return (
                    <div key="1" className="checkboxgroup">
                      <input
                        id={String(cost.Id)}
                        className="checkbox"
                        type="checkbox"
                        checked={
                          orderInfo &&
                          orderInfo.Orders &&
                          orderInfo.Orders.length > 0 &&
                          orderInfo.Orders[0] &&
                          orderInfo.Orders[0].VideoCost &&
                          orderInfo.Orders[0].VideoCost.length > 0
                            ? orderInfo.Orders[0].VideoCost.some(
                                (eventCostList) =>
                                  eventCostList.CostName === cost.CostName &&
                                  eventCostList.Cost > 0
                              )
                            : false
                        }
                        onChange={(event) => handleVideoCostChange(event, cost)}
                      />
                      <div className="costname-item">
                        {Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                        }).format(cost.Cost as number)}
                        -{cost.CostName}
                      </div>

                      {/* <span style={{ marginLeft: "5px", color: "#03c04A" }}>
                      {isActive ? "(Purchased)" : <></>}
                    </span> */}
                    </div>
                  );
                })}
              </>
            ) : (
              <></>
            )}
          </div>
        </div>

        {/* end of cost change */}
        {/* </div> */}

        <div
          // className="textarea-wrapper"
          style={{ width: "48%" }}
        >
          <TextField
            className="textarea"
            id="PIcomments"
            name="PIcomments"
            placeholder="Notes"
            value={orderInfo.Comments}
            multiline
            rows={4}
            onChange={(e) => {
              updatePaymentInfo(e);
            }}
          />
          {/* <label className="form-label" htmlFor="PIcomments">
              Comments
            </label> */}
        </div>
      </div>
      {/* Line 4 */}
      <div className="horizontal-wrapper-spacebetween-center">
        <div
          className="order-checkboxgroup"
          style={{ marginTop: "1rem", width: "18%" }}
        >
          <input
            id="NoInvoiceFlag"
            name="NoInvoiceFlag"
            className="checkbox"
            type="checkbox"
            onChange={(e) => updatePaymentInfo(e)}
          />
          <div>
            <span> No Receipt</span>
          </div>
        </div>
        <div
          className="input-field-div-wrapper w-18"
          style={{ marginTop: "2rem" }}
        >
          <input
            className="input-field-div-small"
            id="TotalAmount"
            name="TotalAmount"
            pattern="[0-9]*"
            placeholder=""
            onChange={(e) => {
              updatePaymentInfo(e);
            }}
            value={orderInfo.TotalAmount}
            disabled={true}
            autoComplete="off"
          />
          <label className="form-label" htmlFor="TotalAmount">
            Total Amount
          </label>
        </div>
        <div
          className="input-field-div-wrapper w-18"
          style={{ marginTop: "2rem" }}
        >
          <input
            className="input-field-div-small"
            id="CouponAmount"
            name="CouponAmount"
            pattern="[0-9]*"
            placeholder=""
            onChange={(e) => {
              updatePaymentInfo(e);
            }}
            value={orderInfo.CouponAmount}
            autoComplete="off"
          />
          <label className="form-label" htmlFor="CouponAmount">
            Discount Amount
          </label>
        </div>
        <div
          className="input-field-div-wrapper w-18"
          style={{ marginTop: "2rem" }}
        >
          <input
            className="input-field-div-small"
            id="AmountPaid"
            //name="AmountPaid"
            {...register("AmountPaid", {
              required: "AmountPaid is a required field",
            })}
            //  pattern="[0-9]*"
            type="number"
            // min="0"
            // step="0.01"
            placeholder=""
            onChange={(e) => {
              updatePaymentInfo(e);
            }}
            value={orderInfo.AmountPaid}
            autoComplete="off"
          />
          <label className="form-label" htmlFor="AmountPaid">
            Amount Paid (*)
          </label>
        </div>
      </div>
      <div className="horizontal-wrapper-centeralign">
        <div className="submit-button-div ">
          <Button type="submit">Submit</Button>
        </div>
        {props.operationType !== "CREATE" ? (
          <div className="submit-button-div-small-delete ">
            <DeleteButton type="button" onClick={deleteOrder}>
              Delete
            </DeleteButton>
          </div>
        ) : (
          <></>
        )}
      </div>
    </form>
  );
};

export default EventMemberPaymentInfo;
